import * as React from 'react';
import { get } from 'lodash';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Card } from 'material-ui';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

const LocalLookupDetail: React.SFC<any> = ({ registrationNumber, vinNumber, owner }) => (
  <Card style={{ padding: '15px', margin: '15px 0' }}>
    <Row style={{ paddingBottom: '15px' }}>
      {[
        {
          label: 'Registrační značka',
          value: registrationNumber
        },
        {
          label: 'VIN',
          value: vinNumber
        },
        {
          label: 'Majitel',
          value: get(owner, 'fullName', 'Neznámo')
        }
      ].map(({ label, value }, key) => (
        <Col md={6} key={key} style={{ margin: '5px 0' }}>
          <Row>
            <Col md={6}>
              <div style={{ fontWeight: 'bold' }}>{label}:</div>
            </Col>
            <Col md={6}>
              <div style={{ textAlign: 'right' }}>{value}</div>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  </Card>
);

export const LocalLookupsForm = ({ items, closeItem }) => (
  <div style={{ margin: '15px' }}>
    <Grid fluid={true}>
      <Card
        style={{
          height: '300px',
          overflow: 'auto'
        }}
      >
        {items.map((o, i) => (
          <LocalLookupDetail key={i} {...get(o, 'vehicle', {})} />
        ))}
        {!items.length && <h4>Žádná vozidla nebyla nalezena</h4>}
      </Card>
    </Grid>
    <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/vehicle/LocalLookupsForm.tsx